import { useLocation, useNavigate } from "react-router-dom";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import { useContext, useEffect, useRef, useState } from "react";
import Select from "../../Form/Select";
import { BandoService } from "../../../services/BandoService";
import { RevocheService } from "../../../services/RevocheService";
import { FormUtility } from "../../Utility/FormUtility";
import Modal from "../../Utility/Modal/Modal";
import moment from 'moment';
import ToastContext from "../../../contexts/toast";

export default function GestioneGruppiRevoche() {
    const [dtOptions, setDtOptions] = useState({});
    const navigate = useNavigate();
    const [avviso, setAvviso] = useState(null);
    const [avvisi, setAvvisi] = useState([]);
    const [revoca, setRevoca] = useState(null);
    const [gruppoDaInviare,setGruppoDaInviare] = useState(null);

    const location = useLocation();
    const revocheService = new RevocheService();
    const utility = new FormUtility();
    

    /*modale*/
    const [title, setTitle] = useState(null);
    const [actionLabel, setActionLabel] = useState("");
    const [content, setContent] = useState(null);
    const [disabledConfirmBtn, setDisabledConfirmBtn] = useState(true);
    const [isModalOpen, setModalOpen] = useState(false);
    const [closeLabel, setCloseLabel] = useState("Annulla");
    const [spinnerVisible, setSpinnerVisible] = useState(false);
    const [disableCloseBtn, setDisableCloseBtn] = useState(false);
    const [hideActionButton,setHideActionButton] = useState(false);
    /*fine modale*/


    const toastContext = useContext(ToastContext);

    const dtRef = useRef();

    const bandoService = new BandoService();

    const eliminaRevoca = (item) => {
        setTitle("Elimina gruppo");
        setContent(`Sei sicuro di voler eliminare il gruppo di revoche selezionato?`);
        setActionLabel("Conferma");
        setCloseLabel("Annulla");
        setModalOpen(true);
        setDisabledConfirmBtn(false);
        setHideActionButton(false);
        setRevoca(item.id);
    };

    const mostraDomande = (item) =>{
        setTitle("Elenco domande");
        setContent(item.richieste && item.richieste.length>0?  item.richieste.join('\n'):'Nessuna domanda presente');
        setModalOpen(true);
        setDisabledConfirmBtn(false);
        setHideActionButton(true);
        setCloseLabel("Chiudi");
    }

    const inviaRevoca = (id) => {
        setTitle("Invia  email gruppo");
        setContent(`Sei sicuro di voler inviare le email  al gruppo di revoche selezionato?`);
        setActionLabel("Conferma");
        setModalOpen(true);
        setDisabledConfirmBtn(false);
        setGruppoDaInviare(id);
        setHideActionButton(false);
        setCloseLabel("Annulla");
    }

    const gotoNuovoGruppo = () => {
        navigate('/gestione-gruppo-revoche');
    };

    useEffect(() => {
        bandoService.getAll().then((resp) => {
            setAvvisi(resp);
            createDtOptions();
        });
    }, []);

    const onChangeBandoFilter = async (val) => {
        setAvviso(val);
    }

    useEffect(() => {
        createDtOptions();
    }, [avviso]);

    const createDtOptions = () => {
        const dtOpt = {
            columns: [
                {
                    name: 'Id',
                    data: 'id',
                    visible: true,
                    sortable: true,
                    searchable: false,
                },
                {
                    name: 'Avviso',
                    data: null,
                    visible: true,
                    sortable: false,
                    searchable: false,
                    cell: (row, col) => {
                        return (
                            <div className='rtds-justify-between rtds-flex'>
                                <span className='lg:rtds-hidden rtds-font-semibold'>
                                    {col.name}
                                </span>
                                {row.bando.nome}
                            </div>
                        );
                    },
                },
                {
                    name: 'Nome gruppo',
                    data: 'nomeGruppo',
                    visible: true,
                    sortable: true,
                    searchable: true,
                },
                {
                    name: 'Data Invio',
                    data: 'dataInvio',
                    visible: true,
                    sortable: true,
                    searchable: true,
                    cell: (row, col) => {
                        return (
                            <div className='rtds-justify-between rtds-flex'>
                                <span className='lg:rtds-hidden rtds-font-semibold'>
                                    {col.name}
                                </span>
                                {row[col.data]?moment(row[col.data]).format('DD/MM/YYYY HH:mm'):'Non inviato'}
                            </div>
                        );
                    },
                },
                {
          name: "Domande",
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => (
            <div
              className="rtds-inline-flex rtds-gap-1"
              role="group"
              aria-label="Domande"
            >
              <button
                type="button"
                className="rtds-btn rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button"
                onClick={() => mostraDomande(row)}
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--eye`}
                  />
                </svg>
                Visualizza
              </button>{" "}              
            </div>
          ),
        },
                {
                    name: 'Azioni',
                    data: null,
                    visible: true,
                    sortable: false,
                    searchable: false,
                    center: true,
                    cell: (row, col) => (
                        <div
                            className='rtds-inline-flex rtds-gap-1'
                            role='group'
                            aria-label='Azioni'
                        >
                            <button
                                type='button'
                                className='rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                                onClick={() => inviaRevoca(row.id)}
                                disabled={row.inviata}
                                title={row.inviata > 0 ? 'Gruppo di revoche non inviabile essendo già inviato' : 'Invia gruppo di revoche'}
                            >
                                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--paper-airplane`}
                  />
                </svg>
                                Invia
                            </button>{' '}
                            <button
                                type='button'
                                className='rtds-btn--danger rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                                onClick={() => eliminaRevoca(row)}
                                disabled={row.inviata}
                                title={row.inviata > 0 ? 'Gruppo di revoche non eliminabile essendo già inviato' : 'Elimina gruppo di revoche'}
                            >
                                <svg
                                    className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                                    aria-hidden='true'
                                    focusable='false'
                                    role='img'
                                >
                                    <use
                                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--trash`}
                                    />
                                </svg>
                                Elimina
                            </button>
                        </div>
                    ),
                }
            ],
            serverSide: true,
            ajax: revocheService.getAllDt,
            ajaxParams: {
                bandoId: avviso,

            },
            rows: [
            ],
            sorts: [],
            hideSearch: false,
            title: 'Elenco Gruppi Revoche'
        };
        setDtOptions(dtOpt);
    }

    const onCloseModal = async () => {
        setModalOpen(false);
        setDisabledConfirmBtn(true);
        setRevoca(null);
        setGruppoDaInviare(null);        
    };

    const handleModalAction = async () => {
        if (!revoca && !gruppoDaInviare){return;}
        if (revoca){
            revocheService.delete(revoca).then(() => {
                dtRef.current.rerenderDatatable();
                setModalOpen(false);
                toastContext.success('Gruppo di revoche eliminato con successo!', 6000);
            }).catch(error => {
                toastContext.error(utility.getErrorMsg(error), 12000);
            });
        }
        if (gruppoDaInviare){
            revocheService.invia(gruppoDaInviare).then(() => {
                dtRef.current.rerenderDatatable();
                setModalOpen(false);
                toastContext.success('Invio email gruppo di revoche schedulato con successo!', 6000);
            }).catch(error => {
                toastContext.error(utility.getErrorMsg(error), 12000);
            });
        }


        /*if (!rowRef.current) {
            if (!avviso)return;
            anprService.eseguiControllo(avviso).then((resp) => {
                toastContext.success('Schedulato controllo ANPR con successo');  
                dtRef.current.rerenderDatatable();   
                setModalOpen(false); 
            }).catch((error) => {
                toastContext.error(utility.getErrorMsg(error), 12000);      
            });
            return;
        }
        anprService.eseguiControlloSingolaRichiesta(rowRef.current.richiestaId).then(() => {
            rowRef.current = null;
            dtRef.current.rerenderDatatable();
            toastContext.success(
                "Controllo rischedulato con successo",
                6000
            );
            setModalOpen(false);
        })
            .catch((error) => {
                rowRef.current = null;
                toastContext.error(utility.getErrorMsg(error), 12000);
                setModalOpen(false);
            });*/

    };


    return (
        <>
            <div className="rtds-container rtds-py-6">
                <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
                    <div className="rtds-flex rtds-items-center rtds-justify-between">
                        <h1 className="rtds-heading-2">Gestione Gruppi di Revoche</h1>
                    </div>
                    <Select
                        classDiv={"rtds-mt-0 lg:rtds-mt-0"}
                        label={"Avviso"}
                        id={"avviso"}
                        classSelect={""}
                        onChange={(event) => {
                            onChangeBandoFilter(event.target.value ?? null);
                        }}
                        baseOption={"Nessuna selezione"}
                        bindKey={"id"}
                        bindValue={"nome"}
                        options={avvisi}

                    />
                </div>
            </div>

            <DataTableWrapper
                ref={dtRef}
                dtOptions={dtOptions}
                headerButton={
                    <button
                        type="button"
                        className="rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
                        onClick={gotoNuovoGruppo}
                    >
                        <svg
                            className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
                            aria-hidden="true"
                            focusable="false"
                            role="img"
                        >
                            <use
                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
                            />
                        </svg>{" "}
                        Inserisci&nbsp;nuovo&nbsp;gruppo
                    </button>
                }
            />
            
            <Modal
                isOpen={isModalOpen}
                title={title}
                content={content}
                innerContent={``}
                onClose={() => onCloseModal()}
                onAction={handleModalAction}
                actionLabel={actionLabel}
                closeLabel={closeLabel}
                disabledConfirmBtn={disabledConfirmBtn}
                disableCloseBtn={disableCloseBtn}
                confirmLoading={spinnerVisible}
                hideActionButton={hideActionButton}
            >
            </Modal>
        </>
    );

}